import React, { useState } from 'react';

import { Avatar, Box, CircularProgress, Collapse, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getStyles } from './styles';
import { KeyboardArrowDown, KeyboardArrowUp, RadioButtonUnchecked } from '@mui/icons-material';
import { ReactSVG } from 'react-svg';
import { IconSvg } from '../../../utils/globalIcons';
import { useAppContext } from '../../../context/AppContext';
import { useNavigate } from 'react-router-dom';

function AnalyticsHome() {

  const theme = useTheme();
  const styles = getStyles(theme);
  const navigate = useNavigate();

  const [stepIndex, setStepIndex] = useState(null)
  const { guideDataloading, analyticsGuideData } = useAppContext();

  const handleServiceGuide = (type) => {
    try {

      const navigationMap = {
        analytics_dataset_creation_status: "/data-sets/datasource",
        analytics_file_dataset_and_upload_status: "/data-sets/datasource",
        analytics_app_link_dataset_status: "/create-ai-app",
        analytics_app_test_status: "/ai-apps",
        analytics_app_customize_status: "/ai-apps",
        analytics_connector_datasource_status: "/sources/analytics-tool/connectors",
        analytics_datsets_to_app_status: "/data-sets/datasource"
      };

      const path = navigationMap[type] || "/analytics-home";
      navigate(path);

    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={styles.mainContainer}>
      <Box sx={styles.cardContainer}>
        <Box marginTop={'50px'}>

          <Typography sx={{ fontSize: '20px', fontWeight: 700 }}>Welcome to Ameya Analyst</Typography>
          <Typography sx={{ fontSize: '14px', fontWeight: 400, marginTop: '10px' }}>
            Connect your data sources, generate insights with AI powered analytics app and dashboards
          </Typography>

          {guideDataloading ?
            (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '90px' }}>
              <CircularProgress />
            </Box>)
            :
            (<Box>

              <Box marginTop={'40px'}>

                <Box sx={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '15px', backgroundColor: '#ffffff',
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                  borderBottomLeftRadius: stepIndex === 1 ? '0px' : '10px',
                  borderBottomRightRadius: stepIndex === 1 ? '0px' : '10px',
                  border: '1px solid #DEDEDE'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar
                      sx={{ bgcolor: '#0B51C5', height: '32px', width: '32px' }}
                      alt="Remy Sharp"
                    >
                      1
                    </Avatar>
                    <Typography sx={{ fontSize: '16px', fontWeight: 600, marginLeft: '10px' }}>
                      Create your first dataset
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {(analyticsGuideData.analytics_dataset_creation_status && analyticsGuideData.analytics_file_dataset_and_upload_status) && (
                      <ReactSVG src={IconSvg.check3Icon}
                        beforeInjection={(svg) => {
                          svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                        }}
                      />
                    )}
                    <IconButton
                      sx={{ fontSize: '16px', fontWeight: 600, marginLeft: '10px' }}
                      onClick={() => setStepIndex(stepIndex === 1 ? null : 1)}
                    >
                      {stepIndex === 1 ? <KeyboardArrowUp sx={{ color: '#0B51C5' }} /> : <KeyboardArrowDown sx={{ color: '#0B51C5' }} />}
                    </IconButton>
                  </Box>
                </Box>

                <Collapse in={stepIndex === 1} timeout="auto" unmountOnExit
                  sx={{
                    backgroundColor: '#FFFFFF',
                    borderBottomLeftRadius: '10px',
                    borderBottomRightRadius: '10px',
                    border: '1px solid #DEDEDE',
                    borderTop: stepIndex === 1 && 0
                  }}
                >

                  <Box sx={{ padding: '20px' }}>
                    <Box
                      sx={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {analyticsGuideData.analytics_dataset_creation_status
                          ?
                          (<ReactSVG
                            src={IconSvg.check2Icon}
                            beforeInjection={(svg) => {
                              svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                            }}
                          />)
                          : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                        }
                        <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                          Create dataset
                        </Typography>
                      </Box>
                      <Typography
                        onClick={() => handleServiceGuide('analytics_dataset_creation_status')}
                        sx={{ color: '#0B51C5', fontSize: '12px', fontWeight: '600', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                      >
                        CREATE
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px',
                        padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {analyticsGuideData.analytics_file_dataset_and_upload_status
                          ?
                          (<ReactSVG
                            src={IconSvg.check2Icon}
                            beforeInjection={(svg) => {
                              svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                            }}
                          />)
                          : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                        }
                        <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                          Enable files datasource and upload a document
                        </Typography>
                      </Box>
                      <Typography
                        sx={{ color: '#0B51C5', fontSize: '12px', fontWeight: '600', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                        onClick={() => handleServiceGuide('analytics_file_dataset_and_upload_status')}
                      >
                        UPLOAD
                      </Typography>
                    </Box>
                  </Box>
                </Collapse>

              </Box>

              <Box marginTop={'30px'}>

                <Box sx={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '15px', backgroundColor: '#ffffff',
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                  borderBottomLeftRadius: stepIndex === 2 ? '0px' : '10px',
                  borderBottomRightRadius: stepIndex === 2 ? '0px' : '10px',
                  border: '1px solid #DEDEDE'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar
                      sx={{ bgcolor: '#0B51C5', height: '32px', width: '32px' }}
                      alt="Remy Sharp"
                    >
                      2
                    </Avatar>
                    <Typography sx={{ fontSize: '16px', fontWeight: 600, marginLeft: '10px' }}>
                      Generate Answering Bot AI app
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {(analyticsGuideData.analytics_app_link_dataset_status && analyticsGuideData.analytics_app_test_status) && (
                      <ReactSVG src={IconSvg.check3Icon}
                        beforeInjection={(svg) => {
                          svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                        }}
                      />
                    )}
                    <IconButton
                      sx={{ fontSize: '16px', fontWeight: 600, marginLeft: '10px' }}
                      onClick={() => setStepIndex(stepIndex === 2 ? null : 2)}
                    >
                      {stepIndex === 2 ? <KeyboardArrowUp sx={{ color: '#0B51C5' }} /> : <KeyboardArrowDown sx={{ color: '#0B51C5' }} />}
                    </IconButton>
                  </Box>
                </Box>

                <Collapse in={stepIndex === 2} timeout="auto" unmountOnExit
                  sx={{
                    backgroundColor: '#FFFFFF',
                    borderBottomLeftRadius: '10px',
                    borderBottomRightRadius: '10px',
                    border: '1px solid #DEDEDE',
                    borderTop: stepIndex === 2 && 0
                  }}
                >

                  <Box sx={{ padding: '20px' }}>
                    <Box
                      sx={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {analyticsGuideData.analytics_app_link_dataset_status
                          ?
                          (<ReactSVG
                            src={IconSvg.check2Icon}
                            beforeInjection={(svg) => {
                              svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                            }}
                          />)
                          : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                        }
                        <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                          Create app and link a dataset
                        </Typography>
                      </Box>
                      <Typography
                        sx={{ color: '#0B51C5', fontSize: '12px', fontWeight: '600', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                        onClick={() => handleServiceGuide('analytics_app_link_dataset_status')}
                      >
                        CREATE
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px',
                        padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {analyticsGuideData.analytics_app_test_status
                          ?
                          (<ReactSVG
                            src={IconSvg.check2Icon}
                            beforeInjection={(svg) => {
                              svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                            }}
                          />)
                          : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                        }
                        <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                          Test your app
                        </Typography>
                      </Box>
                      <Typography
                        sx={{ color: '#0B51C5', fontSize: '12px', fontWeight: '600', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                        onClick={() => handleServiceGuide('analytics_app_test_status')}
                      >
                        LAUNCH
                      </Typography>
                    </Box>
                  </Box>
                </Collapse>

              </Box>

              <Box marginTop={'30px'}>

                <Box sx={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '15px', backgroundColor: '#ffffff',
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                  borderBottomLeftRadius: stepIndex === 3 ? '0px' : '10px',
                  borderBottomRightRadius: stepIndex === 3 ? '0px' : '10px',
                  border: '1px solid #DEDEDE'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar
                      sx={{ bgcolor: '#0B51C5', height: '32px', width: '32px' }}
                      alt="Remy Sharp"
                    >
                      3
                    </Avatar>
                    <Typography sx={{ fontSize: '16px', fontWeight: 600, marginLeft: '10px' }}>
                      Personalize your AI app and Extend
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {(analyticsGuideData.analytics_app_customize_status &&
                      analyticsGuideData.analytics_connector_datasource_status &&
                      analyticsGuideData.analytics_datsets_to_app_status
                    ) &&
                      (<ReactSVG src={IconSvg.check3Icon}
                        beforeInjection={(svg) => {
                          svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                        }}
                      />
                      )}
                    <IconButton
                      sx={{ fontSize: '16px', fontWeight: 600, marginLeft: '10px' }}
                      onClick={() => setStepIndex(stepIndex === 3 ? null : 3)}
                    >
                      {stepIndex === 3 ? <KeyboardArrowUp sx={{ color: '#0B51C5' }} /> : <KeyboardArrowDown sx={{ color: '#0B51C5' }} />}
                    </IconButton>
                  </Box>
                </Box>

                <Collapse in={stepIndex === 3} timeout="auto" unmountOnExit
                  sx={{
                    backgroundColor: '#FFFFFF',
                    borderBottomLeftRadius: '10px',
                    borderBottomRightRadius: '10px',
                    border: '1px solid #DEDEDE',
                    borderTop: stepIndex === 3 && 0
                  }}
                >

                  <Box sx={{ padding: '20px' }}>
                    <Box
                      sx={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {analyticsGuideData.analytics_app_customize_status
                          ?
                          (<ReactSVG
                            src={IconSvg.check2Icon}
                            beforeInjection={(svg) => {
                              svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                            }}
                          />)
                          : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                        }
                        <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                          Customize branding
                        </Typography>
                      </Box>
                      <Typography
                        sx={{ color: '#0B51C5', fontSize: '12px', fontWeight: '600', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                        onClick={() => handleServiceGuide('analytics_app_customize_status')}
                      >
                        CONFIGURE
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px',
                        padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {analyticsGuideData.analytics_connector_datasource_status
                          ?
                          (<ReactSVG
                            src={IconSvg.check2Icon}
                            beforeInjection={(svg) => {
                              svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                            }}
                          />)
                          : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                        }
                        <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                          Add more data using connectors
                        </Typography>
                      </Box>
                      <Typography
                        sx={{ color: '#0B51C5', fontSize: '12px', fontWeight: '600', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                        onClick={() => handleServiceGuide('analytics_connector_datasource_status')}
                      >
                        LEARN
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px',
                        padding: '10px', backgroundColor: '#ffffff', borderRadius: '10px', border: '1px solid #DEDEDE'
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {analyticsGuideData.analytics_datsets_to_app_status
                          ?
                          (<ReactSVG
                            src={IconSvg.check2Icon}
                            beforeInjection={(svg) => {
                              svg.setAttribute('style', 'width: 24px; height: 24px; display: block;');
                            }}
                          />)
                          : (<RadioButtonUnchecked sx={{ width: 24, height: 24, color: '#C4C4C4' }} />)
                        }
                        <Typography sx={{ fontSize: '14px', fontWeight: 500, marginLeft: '10px' }}>
                          Create more datasets and add to the app
                        </Typography>
                      </Box>
                      <Typography
                        sx={{ color: '#0B51C5', fontSize: '12px', fontWeight: '600', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                        onClick={() => handleServiceGuide('analytics_datsets_to_app_status')}
                      >
                        CREATE
                      </Typography>
                    </Box>

                  </Box>
                </Collapse>
              </Box>

            </Box>)
          }

        </Box>
      </Box>
    </div >

  )
}

export default AnalyticsHome;